import { render, staticRenderFns } from "./RegisterDoctorFormV2.vue?vue&type=template&id=bf9ace6a&scoped=true"
import script from "./RegisterDoctorFormV2.vue?vue&type=script&lang=js"
export * from "./RegisterDoctorFormV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9ace6a",
  null
  
)

export default component.exports